import api from '@pray/shared/utils/api';

import type { RecurringCampaignDetail, UpdateRecurringCampaignPayload } from './types';

// PATCH …/campaigns/recurring/:id — partial update, status-gated server-side.
// The payload should carry only fields editable for the current status; the
// server rejects anything else with RECURRING_FIELD_NOT_EDITABLE.
export async function updateRecurringCampaign({
  artistId,
  recurringCampaignId,
  payload,
}: {
  artistId: string;
  recurringCampaignId: string;
  payload: UpdateRecurringCampaignPayload;
}): Promise<{ object: RecurringCampaignDetail }> {
  if (!artistId) throw new Error('Artist ID is required');
  if (!recurringCampaignId) throw new Error('Recurring campaign ID is required');

  const url = `/web/studio/artists/${artistId}/campaigns/recurring/${recurringCampaignId}`;
  const response = await api.executePatchRequest<{ data: { object: RecurringCampaignDetail } }>(url, payload);
  return response.data.data;
}
